import { FC, useEffect, useState } from 'react';

import { TableBody, TableRow } from '@mui/material';
import { FaRegListAlt } from 'react-icons/fa';
import { FiSearch } from 'react-icons/fi';

import { AdminTitle } from '../../components/AdminTitle';
import { StyledInput } from '../../components/StyledInput';
import NewDataTable from '../../components/StyledTableContentRaw';

import { IOrders, useOrdersInfo } from '../../services/hooks/orders';

import moment from 'moment';
import { DateRange } from 'rsuite/esm/DateRangePicker';
import StyledDateRangeSelect from '../../components/DashBoardComponents/StyledDateRangeSelect';
import ReactSelect from '../../components/ReactSelect';
import { ModalOrderDetails } from './ModalOrderDetails';
import { FiltersContainer, OrdersContainer, TdConsult } from './style';

const Orders: FC = () => {
  const [text, setText] = useState<string | undefined>(undefined);
  const [filterDateRange, setFilterDateRange] = useState<DateRange | null>(
    null,
  );
  const [filterStatus, setFiterStatus] = useState<
    { value: string; label: string } | undefined
  >(undefined);

  const [order, setOrder] = useState<'desc' | 'asc'>('asc');
  const [orderBy, setOrderBy] = useState('updated_at');
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);

  const [orderSelected, setOrderSelected] = useState<IOrders>();
  const [showModalOrderDetails, setShowModalOrderDetails] =
    useState<boolean>(false);

  const { data, isLoading, error } = useOrdersInfo({
    resultsPerPage: itemsPerPage,
    page: page,
    text: text && text.length > 2 ? text : undefined,
    status: filterStatus?.value || undefined,
    dataInitialConsulta: filterDateRange
      ? moment(filterDateRange[0]).startOf('day').toDate()
      : undefined,
    dataEndConsulta: filterDateRange
      ? moment(filterDateRange[1]).endOf('day').toDate()
      : undefined,
    orderByDirection: order,
    orderBy,
  });

  const headers = [
    { key: 'consulta', label: 'Consulta' },
    { key: 'created_at', label: 'Data' },
    { key: 'placa', label: 'Placa do carro' },
    { label: 'Valor' },
    { key: 'status', label: 'Status' },
    { label: 'Forma de pagamento' },
  ];

  const statusOpt = [
    { value: 'APROVADO', label: 'Aprovado' },
    { value: 'CONSULTA', label: 'Consulta' },
    { value: 'LIQUIDADO', label: 'Liquidado' },
    { value: 'NEGADO', label: 'Negado' },
    { value: 'PROCESSAMENTO', label: 'Em processamento' },
  ];

  useEffect(() => {
    setPage(1);
  }, [data?.resultsPerPage, data?.total, itemsPerPage]);

  return (
    <OrdersContainer>
      {showModalOrderDetails && (
        <ModalOrderDetails
          order={orderSelected}
          setModalOpen={setShowModalOrderDetails}
          modalOpen={showModalOrderDetails}
        />
      )}
      <AdminTitle
        title="Listagem de Pedidos"
        icon={<FaRegListAlt size={20} color="#4D4C4D" />}
      />
      <FiltersContainer>
        <label htmlFor="">
          <div className="searchInput">
            <StyledInput
              placeholder="Buscar por consulta ou placa"
              value={text}
              onChange={(e) =>
                setText((e?.target?.value ?? '').replace(/([^\w ]|_)/g, ''))
              }
            />
          </div>
          <span className="iconSearch">
            <FiSearch />
          </span>
        </label>
        <label className="otherInput" htmlFor="">
          <StyledDateRangeSelect
            placeholder="Filtrar período"
            setSelectedRangeDate={setFilterDateRange}
            value={filterDateRange}
          />
        </label>
        <label className="otherInput select" htmlFor="">
          <ReactSelect
            placeholder="Status"
            isLoading={false}
            allOptions={statusOpt}
            setSelectedOption={setFiterStatus}
            value={filterStatus}
            name="status"
            isClearable
          />
        </label>
      </FiltersContainer>

      <NewDataTable
        title="Listagem de Pedidos"
        heads={headers}
        hasPagination
        data={data?.results}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        page={Number(data?.currentPage as string)}
        setPage={setPage}
        setItemsPerPage={setItemsPerPage}
        nPages={data?.nPages}
        isLoading={isLoading}
        error={error}
        totalItems={data?.total}
        itemsPerPage={itemsPerPage}
      >
        <TableBody>
          {data &&
            data.results?.map((each, i) => (
              <TableRow key={each?.consulta}>
                <TdConsult
                  className="consulta"
                  onClick={() => {
                    setShowModalOrderDetails(true);
                    setOrderSelected(each);
                  }}
                >
                  #{each?.consulta}
                </TdConsult>
                <td>{moment(each?.created_at).format('DD/MM/YYYY')}</td>
                <td>{each?.placa}</td>
                <td>
                  {each?.payloadCaptura?.valor
                    ? Number(each?.payloadCaptura?.valor).toLocaleString(
                        'pt-BR',
                        {
                          style: 'currency',
                          currency: 'BRL',
                          minimumFractionDigits: 2,
                        },
                      )
                    : 'R$ 00,00'}
                </td>
                <td>{each?.status}</td>
                <td>
                  {each?.payloadCaptura?.cardNumber ||
                  each?.payloadCaptura?.cartoes?.length ? (
                    'Cartão de Crédito'
                  ) : (
                    <>PIX</>
                  )}
                </td>
              </TableRow>
            ))}
        </TableBody>
      </NewDataTable>
    </OrdersContainer>
  );
};

export default Orders;
